exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fa-pencil-alt {\n    position: relative;\n    top: -4px;\n}\n.font-small {\n    font-size: .80em;\n}    \n", ""]);

// exports
